module.exports = __webpack_public_path__ + "static/media/falcon.920a9ff0.png";